﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKBreadcrumb extends TKCustomElementFactory {
    scrollingWrapper?: HTMLElement;

    constructor() {
        super();

        this.scrollingWrapper = this.querySelector('[data-tk-scrolling-wrapper]') || undefined;
    }

    connectedCallback(): void {
        if (!this.scrollingWrapper) return;
        this.scrollEnd();
    }

    scrollEnd() {
        const { scrollWidth } = this.scrollingWrapper!;
        const { width } = this.scrollingWrapper!.getBoundingClientRect();
        this.scrollingWrapper?.scrollTo({ behavior: 'smooth', left: scrollWidth - width });
    }
}
